// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyCSP4D64U_8fcW2WWT6m7A20zarJjDtNls',
  authDomain: 'ionic-alarm-853ce.firebaseapp.com',
  projectId: 'ionic-alarm-853ce',
  storageBucket: 'ionic-alarm-853ce.appspot.com',
  messagingSenderId: '206722927735',
  appId: '1:206722927735:web:6faa1fb1f9579adcfeca72',
  measurementId: 'G-1RG90ZRQW0',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
